/* eslint-disable react/require-default-props */
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Flex, Pane } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import useTwoFactorVerify from "./hooks/useTwoFactorVerify.js";
import { TwoFactoryVerifyDefaultProps } from "./Constants.js";
import S from './Login.css';
import TwoFactorSubmitForm from "./views/TwoFactorSubmitForm.js";
import TwoFactorSelectForm from "./views/TwoFactorSelectForm.js";
const {
  t
} = I18N.ns('login.TwoFactorVerify');
function TwoFactorVerify(props) {
  const {
    classNames: {
      className,
      backClassName,
      backupCodeClassname,
      codeClassName,
      rememberMeClassName,
      submitClassName,
      warningClassName
    },
    components: {
      ErrorComponent,
      LoadingComponent,
      LogoComponent,
      TwoFactorVerifyInstructionComponent
    },
    variants: {
      variant,
      backToLoginVariant,
      backupCodeVariant,
      codeVariant,
      loginLogoVariant,
      resendCodeVariant,
      rememberMeVariant,
      warningVariant
    },
    options: {
      getShouldDisplayLogo,
      warningLocation
    },
    state: {
      code,
      error,
      loading,
      onBackupCodeClick,
      onChangeCode,
      onChangeRememberMe,
      onChangeSelectedTwoFactorMethod,
      onReset2FAMethod,
      onSubmit,
      rememberMe,
      selectedTwoFactorMethod,
      requestedTwoFactorMessage,
      onRequest2FACode,
      submitDisabled,
      twoFactorSettings,
      userTwoFactorMethods
    },
    onBackToLogin
  } = useTwoFactorVerify(props);
  const displayLogo = getShouldDisplayLogo(props, 'login/twoFactorVerify');
  return /*#__PURE__*/React.createElement(Pane, {
    variant: variant,
    className: classnames(className, S.pane),
    layout: "flex:colS"
  }, twoFactorSettings === undefined && /*#__PURE__*/React.createElement("div", {
    className: S.blocker
  }, /*#__PURE__*/React.createElement(LoadingComponent, {
    color: "var(--color-brand500)",
    style: {
      position: 'absolute',
      top: '50%',
      left: '50%'
    }
  })), /*#__PURE__*/React.createElement(Flex, {
    inline: true,
    variant: "colM",
    align: "center"
  }, displayLogo && LogoComponent ? /*#__PURE__*/React.createElement(LogoComponent, {
    variant: loginLogoVariant
  }) : null, warningLocation === 'top' && ErrorComponent ? /*#__PURE__*/React.createElement(ErrorComponent, {
    variant: warningVariant,
    className: warningClassName,
    error: error
  }) : null, TwoFactorVerifyInstructionComponent && /*#__PURE__*/React.createElement(TwoFactorVerifyInstructionComponent, {
    selectedTwoFactorMethod: selectedTwoFactorMethod,
    requestedTwoFactorMessage: requestedTwoFactorMessage
  }), requestedTwoFactorMessage ? /*#__PURE__*/React.createElement(TwoFactorSubmitForm, {
    twoFactorMethods: userTwoFactorMethods,
    codeVariant: codeVariant,
    codeClassName: codeClassName,
    code: code,
    onChangeCode: onChangeCode,
    twoFactorSettings: twoFactorSettings,
    rememberMeVariant: rememberMeVariant,
    rememberMeClassName: rememberMeClassName,
    rememberMe: rememberMe,
    onChangeRememberMe: onChangeRememberMe,
    twoFactorMethod: selectedTwoFactorMethod,
    resendCodeVariant: resendCodeVariant,
    onReset2FAMethod: onReset2FAMethod,
    submitClassName: submitClassName,
    onSubmit: onSubmit,
    loading: loading,
    LoadingComponent: LoadingComponent,
    backToLoginVariant: backToLoginVariant,
    backClassName: backClassName,
    onBackToLogin: onBackToLogin,
    backupCodeVariant: backupCodeVariant,
    backupCodeClassname: backupCodeClassname,
    onBackupCodeClick: onBackupCodeClick
  }) : /*#__PURE__*/React.createElement(TwoFactorSelectForm, {
    twoFactorMethods: userTwoFactorMethods,
    selectedMethod: selectedTwoFactorMethod,
    onChangeSelectedTwoFactorMethod: onChangeSelectedTwoFactorMethod,
    onRequest2FACode: onRequest2FACode
  }), /*#__PURE__*/React.createElement(Button, {
    variant: backToLoginVariant,
    className: backClassName,
    type: "button",
    onClick: onBackToLogin
  }, t('backText'))));
}
export default connect(state => {
  return {
    auth: state.auth
  };
})(TwoFactorVerify);
TwoFactorVerify.propTypes = {
  classNames: PropTypes.exact({
    className: PropTypes.string,
    backClassName: PropTypes.string,
    backupCodeClassname: PropTypes.string,
    codeClassName: PropTypes.string,
    rememberMeClassName: PropTypes.string,
    submitClassName: PropTypes.string,
    warningClassName: PropTypes.string
  }),
  components: PropTypes.exact({
    ErrorComponent: PropTypes.elementType,
    LoadingComponent: PropTypes.elementType,
    LogoComponent: PropTypes.elementType,
    TwoFactorVerifyInstructionComponent: PropTypes.elementType
  }),
  variants: PropTypes.exact({
    variant: PropTypes.string,
    backToLoginVariant: PropTypes.string,
    backupCodeVariant: PropTypes.string,
    resendCodeVariant: PropTypes.string,
    rememberMeVariant: PropTypes.string,
    twoFactorMethodRadioVariant: PropTypes.string,
    warningVariant: PropTypes.string
  }),
  options: PropTypes.exact({
    getShouldDisplayLogo: PropTypes.func,
    warningLocation: PropTypes.oneOf(['top', 'bottom'])
  })
};